import { defineComponent as _defineComponent } from 'vue'
import {computed} from 'vue';
import {useStore} from '@/store/useStore';
import NoAccess from './NoAccess.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseLayout',
  setup(__props) {

const store = useStore();
const permission = computed(() => store.getters.userInfo.permission);

return { __sfc: true,store, permission, NoAccess }
}

})